( function($) {
    $( window ).ready(function() {
        /* On isotope v2 hidden class is not defined. Add hidden class if item hidden, before initialising Isotope: */
        var itemReveal = Isotope.Item.prototype.reveal;
        Isotope.Item.prototype.reveal = function() {
            itemReveal.apply( this, arguments );
            $( this.element ).removeClass('isotope-hidden');
        };
        var itemHide = Isotope.Item.prototype.hide;
        Isotope.Item.prototype.hide = function() {
            itemHide.apply( this, arguments );
            $( this.element ).addClass('isotope-hidden');
        };
        Isotope.Item.prototype._create = function() {
            // assign id, used for original-order sorting
            this.id = this.layout.itemGUID++;
            // transition objects
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            };
            this.sortData = {};
        };
        Isotope.Item.prototype.layoutPosition = function() {
            this.emitEvent( 'layout', [ this ] );
        };
        Isotope.prototype.arrange = function( opts ) {
            // set any options pass
            this.option( opts );
            this._getIsInstant();
            // just filter
            this.filteredItems = this._filter( this.items );
            // flag for initalized
            this._isLayoutInited = true;
        };
        // layout mode that does not position items
        Isotope.LayoutMode.create('none');
        function filterBtns() {

            // var wrap = $('.gallery-container'),
            var wrap = $('.videogallery-wrap'),
                btns = $('.filter-item '),
                mobileFilter = $('.filters_select');
            if (wrap.length > 0) {
                var $grid = wrap.isotope({
                    // itemSelector: '.gallery__item',
                    // itemSelector: '.single-image',
                    itemSelector: '.single-gallery-item',
                    percentPosition: true,
                    layoutMode: 'none'
                });
                btns.click(function () {
                    // var filterValue = $(this).attr('data-filter-value'),
                    AOS.init({
                        disable: true

                    });
                    var filterValue = $(this).data('category'),
                        newRel = filterValue.replace('.', '');
                    if( newRel === '*' ){
                        newRel = 'gallery';
                    }
                    btns.removeClass('current');
                    $(this).addClass('current');
                    $grid.find(filterValue).find('.fancy').attr("data-fancybox", newRel);
                    $grid.isotope({filter: filterValue});
                });
                mobileFilter.on('change', function(){
                    var filterValue = $(this).find(':selected').attr('data-filter-value'),
                        newRel = filterValue.replace('.', '');
                    if( newRel === '*' ){
                        newRel = 'gallery';
                    }
                    $grid.find(filterValue).find('.fancy').attr("data-fancybox", newRel);
                    $grid.isotope({filter: filterValue});
                });

                // wrap.imagesLoaded({ background: '.thumb' }).done(function() {
                // $grid.fadeIn(1000).isotope('layout');
                // });
            }
        }
        filterBtns();
        $('[data-fancybox="gallery"]').fancybox({
            toolbar  : false,
            smallBtn : false,
            arrows   : false,
            idleTime : false,
            loop     : true,
            padding   : [ 44, 60 ],
            transitionEffect : false,
            animationDuration : 0,

            caption : function( instance, item ) {
                return $(this).find('figcaption').html();
            },
            beforeShow: function() {
                $('.caption--image').remove();
            },
            afterShow : function(instance, slide) {
                $('<button type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small" title="Close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button><a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span></span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span></span></a>').appendTo( slide.$content );
                var caption = $(".fancybox-caption"),
                    innerCaption = caption.clone().addClass('caption--image');
                $(".fancybox-slide--current .fancybox-content").append(innerCaption);
                caption.not('.caption--image').addClass('caption--bottom');
            },
            afterLoad : function(instance, current) {
                if( typeof current.$image !== 'undefined' ){
                    current.$image.attr('alt', current.opts.$orig.find('img').attr('alt'));
                    current.$image.attr('title', current.opts.$orig.find('img').attr('title'));
                }
            }
        });

    });
} ( jQuery ) );